export const SEARCHBOX_RENDERING_THRESHOLD = 20;

export const UNFILTERABLE_FACET_IDS = ["currentprice"];
